import React, { useRef } from "react";
import { Modal, Button } from "react-bootstrap";

const RootCauseConfirmationModal = ({
  show,
  handleClose,
  handleConfirm,
  title,
  message,
}) => {
  const modalRef = useRef(null);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      animation
      transition={{ nodeRef: modalRef }}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title || "Confirm Action"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p
          style={{
            color: "red",
            fontWeight: "500",
          }}
        >
          {message || "Are you sure you want to proceed?"}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <button className="c-b-btn" onClick={handleClose}>
          Cancel
        </button>
        <button className="n-u-btn" onClick={handleConfirm}>
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default RootCauseConfirmationModal;
